import React from "react";
import * as Lucide from "lucide-react";

// Render a lucide-react icon by name with a safe fallback.
export function Icon({ name, className = "", ...props }) {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp className={className} {...props} />;
}
